<template>
  <Teleport to="body">
    <Transition name="cd-fade">
      <div v-if="visible" class="cd" @click.self="respond(false)">
        <div class="cd__box" dir="rtl" role="alertdialog" aria-modal="true">

          <div class="cd__icon" :class="{ 'cd__icon--danger': options.danger }">
            <i :class="options.icon || (options.danger ? 'fa fa-exclamation' : 'fa fa-circle-question')"></i>
          </div>

          <h3 class="cd__title">{{ options.title }}</h3>
          <p v-if="options.message" class="cd__message">{{ options.message }}</p>

          <div class="cd__actions">
            <button
              class="cd__btn cd__btn--confirm"
              :class="{ 'cd__btn--danger': options.danger }"
              @click="respond(true)"
              type="button"
            >{{ options.confirmText }}</button>
            <button class="cd__btn cd__btn--cancel" @click="respond(false)" type="button">
              {{ options.cancelText }}
            </button>
          </div>

        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { useConfirm } from "@/composables/useConfirm";

const { visible, options, respond } = useConfirm();
</script>

<style scoped lang="scss">
.cd {
  position: fixed; inset: 0;
  z-index: 10001; // above ReportSheet (10000) and the lightboxes
  background: rgba(0, 0, 0, 0.6);
  display: flex; align-items: center; justify-content: center;
  padding: var(--page-padding-x);

  &__box {
    width: 100%; max-width: 340px;
    background: var(--color-panel);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-xl);
    padding: var(--space-5) var(--space-4) var(--space-4);
    display: flex; flex-direction: column; align-items: center;
    text-align: center;
    box-shadow: 0 24px 60px -12px rgba(0, 0, 0, 0.6);
  }

  &__icon {
    width: 52px; height: 52px; border-radius: 50%;
    background: var(--color-signal-soft);
    color: var(--color-signal);
    display: grid; place-items: center;
    font-size: 1.15rem;
    margin-bottom: var(--space-3);

    &--danger {
      background: var(--color-closed-soft);
      color: var(--color-closed, #D86545);
    }
  }

  &__title {
    margin: 0 0 var(--space-1);
    font-size: 1rem; font-weight: 800; color: var(--color-text-1);
  }

  &__message {
    margin: 0;
    font-size: 0.85rem; line-height: 1.7; color: var(--color-text-3);
  }

  &__actions {
    display: flex; flex-direction: column; gap: var(--space-2);
    width: 100%;
    margin-top: var(--space-4);
  }

  &__btn {
    width: 100%; padding: 12px;
    border-radius: var(--radius-md);
    font-family: var(--font-primary); font-size: 0.88rem; font-weight: 700;
    cursor: pointer; transition: all var(--transition-base);

    &--confirm {
      border: none;
      background: linear-gradient(135deg, var(--color-signal, #E2B673), #C29250);
      color: #1a1410;
      &:hover { opacity: 0.92; }
    }

    &--danger {
      background: var(--color-closed, #D86545);
      color: #fff;
    }

    &--cancel {
      background: none;
      border: 1px solid var(--color-border);
      color: var(--color-text-3);
      &:hover { border-color: var(--color-border-lit); color: var(--color-text-1); }
    }
  }
}

.cd-fade-enter-active,
.cd-fade-leave-active {
  transition: opacity 0.18s ease;
  .cd__box { transition: transform 0.2s ease; }
}
.cd-fade-enter-from,
.cd-fade-leave-to {
  opacity: 0;
  .cd__box { transform: scale(0.94); }
}
</style>
